const verifyForm = document.querySelector('#verification-form');
const inputs = verifyForm.querySelectorAll('input');
const KEYBOARDS = {
  backspace: 8,
  arrowLeft: 37,
  arrowRight: 39,
};

function handleInput(e) {
  const input = e.target;
  const nextInput = input.nextElementSibling;
  if (nextInput && input.value) {
    nextInput.focus();
    if (nextInput.value) {
      nextInput.select();
    }
  }
}

function handlePaste(e) {
  e.preventDefault();
  const paste = e.clipboardData.getData('text');
  inputs.forEach((input, i) => {
    input.value = paste[i] || '';
  });
}

function handleBackspace(e) {
  const input = e.target;
  if (input.value) {
    input.value = '';
    return;
  }

  input.previousElementSibling.focus();
}

function handleArrowLeft(e) {
  const previousInput = e.target.previousElementSibling;
  if (!previousInput) return;
  previousInput.focus();
}

function handleArrowRight(e) {
  const nextInput = e.target.nextElementSibling;
  if (!nextInput) return;
  nextInput.focus();
}

verifyForm.addEventListener('input', handleInput);
inputs[0].addEventListener('paste', handlePaste);

inputs.forEach(input => {
  input.addEventListener('focus', e => {
    setTimeout(() => {
      e.target.select();
    }, 0);
  });

  input.addEventListener('keydown', e => {
    switch(e.keyCode) {
      case KEYBOARDS.backspace:
        handleBackspace(e);
        break;
      case KEYBOARDS.arrowLeft:
        handleArrowLeft(e);
        break;
      case KEYBOARDS.arrowRight:
        handleArrowRight(e);
        break;
      default:
    }
  });
});

document.querySelector('.container-modal .modal-content-wrapper .content-block button').addEventListener('click', function(event){
  event.preventDefault();
  // Get Verification Codes from data attribute
  let verifyCodes = JSON.parse(verifyForm.getAttribute('data-verify-codes'));
  let inputValues = document.querySelectorAll('.container-modal .modal-content-wrapper .content-block .form-control');
  let userVerifyCode = '';
  // Get User Input Numbers
  inputValues.forEach((input) => {
    userVerifyCode += input.value;
  });

  // Loop verifyCodes Array and Find matching Code
  let codeMatched  = false;
     verifyCodes.forEach((val) =>{
       if(Number(val) === Number(userVerifyCode)){
           codeMatched = true;
       }
     });
  //Check if User input value contains text Show Error Message if not Close popup;
  let pattern = /[a-z]/gi;
  if(!pattern.test(userVerifyCode) && codeMatched){
    document.getElementById("form-btn-loder").style.display = "block";
    document.getElementById("form-btn-text").style.display = "none";
    setTimeout(function(){
        document.querySelector('.container-modal').classList.remove('popup-show');
        document.querySelectorAll('.container-modal .modal-content-wrapper .content-block .error-txt, .container-modal .modal-content-wrapper .content-block .error-txt p').forEach(function(el){ el.style.display = 'none'; });
        // When user Verified Code Correctly, Value Set in Local Storage for Avoid Verification Popup
        localStorage.setItem("verification Code Verified", true);
    }, 2000);

  }else{
    document.querySelectorAll('.container-modal .modal-content-wrapper .content-block .error-txt, .container-modal .modal-content-wrapper .content-block .error-txt p').forEach(function(el){ el.style.display = ''; });
  }

});

if(localStorage.getItem('verification Code Verified')){
  document.querySelector('.container-modal').classList.remove('popup-show');
}
